module.exports = __webpack_public_path__ + "static/img/Lark20201020-141431.95fd9bac.png";